import { Box, BoxProps, createStyles, CSSObject } from "@mantine/core";
import React from "react";
import { PolymorphicComponentProps } from "@mantine/utils";

interface GridProps {
  inline?: boolean;
  fullWidth?: boolean;
  columns?: CSSObject["gridTemplateColumns"];
  rows?: CSSObject["gridTemplateRows"];
  template?: CSSObject["gridTemplate"];
  gap?: CSSObject["gap"];
  columnGap?: CSSObject["columnGap"];
  rowGap?: CSSObject["rowGap"];
  justifyItems?: CSSObject["justifyItems"];
  alignItems?: CSSObject["alignItems"];
  placeItems?: CSSObject["placeItems"];
  justify?: CSSObject["justifyContent"];
  align?: CSSObject["alignContent"];
  place?: CSSObject["placeContent"];
}

type ExtendedGridProps = GridProps &
  Pick<
    PolymorphicComponentProps<"div", BoxProps>,
    "children" | "className" | "sx" | `${"m" | "p"}${"" | "b" | "t" | "l" | "r" | "x" | "y"}` | "onClick"
  >;

type GridType = React.FC<ExtendedGridProps>;

export const useGridStyles = createStyles<"root", GridProps>((_, props) => {
  return {
    root: {
      display: props.inline ? "inline-grid" : "grid",
      ...(props.fullWidth && { width: "100%" }),

      gridTemplateColumns: props.columns,
      gridTemplateRows: props.rows,
      gridTemplate: props.template,
      gap: props.gap,
      columnGap: props.columnGap,
      rowGap: props.rowGap,
      justifyItems: props.justifyItems,
      alignItems: props.alignItems,
      placeItems: props.placeItems,
      justifyContent: props.justify,
      alignContent: props.align,
      placeContent: props.place,
    },
  };
});

export const Grid: GridType = ({
  className,
  sx,
  children,

  m,
  mb,
  mt,
  ml,
  mr,
  mx,
  my,
  p,
  pb,
  pt,
  pl,
  pr,
  px,
  py,
  onClick,
  ...props
}) => {
  const { classes, cx } = useGridStyles(props);
  return (
    <Box
      className={cx(classes.root, className)}
      sx={sx}
      children={children}
      {...{ m, mb, mt, ml, mr, mx, my, p, pb, pt, pl, pr, px, py, onClick }}
    />
  );
};
